import { Schedule } from 'src/classes/schedule';

function hasWorkDaysOnly(array: number[]) {
  return (
    array.includes(1) &&
    array.includes(2) &&
    array.includes(3) &&
    array.includes(4) &&
    array.includes(5) &&
    !array.includes(0) &&
    !array.includes(6)
  );
}

function hasWeekendOnly(array: number[]) {
  return (
    !array.includes(1) &&
    !array.includes(2) &&
    !array.includes(3) &&
    !array.includes(4) &&
    !array.includes(5) &&
    array.includes(0) &&
    array.includes(6)
  );
}

function convertWeeknumberToDay(weekNumber: number) {
  return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][weekNumber];
}

function getTimeString(hour: number, minute: number, allowText = true) {
  if (isNaN(hour)) {
    return 'Hour NaN';
  }
  if (isNaN(minute)) {
    return 'Minute NaN';
  }
  if (allowText) {
    if (hour === 0 && minute === 0) {
      return 'midnight';
    }
    if (hour === 12 && minute === 0) {
      return 'midday';
    }
  }
  return hour.toString().padStart(2, '0') + ':' + minute.toString().padStart(2, '0');
}

// From array [1, 2, 3] returns string "1, 2 and 3"
export function joinWithAnd(array: number[] | string[]): string {
  let result = '';
  for (let i = 0; i < array.length; i++) {
    if (i !== 0) {
      if (i + 1 === array.length) {
        result += ' and ';
      } else {
        result += ', ';
      }
    }
    result += array[i].toString();
  }
  return result;
}


export function extractRuleFromScheduleData(typeCode: 'H' | 'D' | 'W' | 'M', ruleString: string) {

  if (typeof ruleString !== 'string' || ruleString.trim() === '') {
    switch (typeCode) {
      case 'H': return 'every minute';
      case 'D': return 'every hour';
      case 'W': return 'every day';
      case 'M': return 'every day';
      default: return 'Unknown';
    }
  }
  if (!typeCode || !ruleString || ruleString[0] !== '{') {
    return 'Unknown';
  }
  const rule = JSON.parse(ruleString);
  if (!rule) {
    return 'Invalid ruleset';
  }
  if (typeof rule.minute === 'object' && rule.minute instanceof Array && typeof rule.minute[0] === 'number') {
    rule.minute = rule.minute[0];
  }
  var days;
  try{
    days=JSON.parse(rule.dayOfWeek)
  }
  catch(e){
    days = rule.dayOfWeek;
  }
  if (typeCode === 'W' && typeof rule.dayOfWeek === 'object' && days instanceof Array) {
    if (hasWorkDaysOnly(rule.dayOfWeek as number[])) {
      if (rule.hour instanceof Array) {
        rule.hour = rule.hour[0];
      }
      if (!rule.hour || (rule.hour === '00' && rule.minute === '00')) {
        return 'on workdays at mid-night';
      } else if (!rule.hour || (rule.hour === '12' && rule.minute === '00')) {
        return 'on workdays at mid-day';
      } else {
        return `on workdays at ${getTimeString(parseInt(rule.hour, 10), parseInt(rule.minute, 10))}`;
      }
    } else if (hasWeekendOnly(rule.dayOfWeek as number[])) {
      if (rule.hour instanceof Array) {
        rule.hour = rule.hour[0];
      }
      if (typeof rule.hour !== 'number' || typeof rule.minute !== 'number') {
        return '(missing \'hour\' or \'minute\' on rule object)';
      } else {
        return `on weekend at ${getTimeString(parseInt(rule.hour, 10), parseInt(rule.minute, 10))}`;
      }
    } else {
      return `at ${joinWithAnd((rule.dayOfWeek as number[]).map(convertWeeknumberToDay))} at ` +
        `${rule.hour.toString().padStart(2, '0')}:${rule.minute.toString().padStart(2, '0')}`;
    }
  } else if (typeCode === 'M') {
    if (rule.hour instanceof Array) {
      rule.hour = rule.hour[0];
    }
    if (typeof rule.hour !== 'number') {
      rule.hour = 0;
    }
    if (typeof rule.minute !== 'number') {
      rule.minute = 0;
    }
    if (rule.date instanceof Array) {
      return `on ${(rule.date.length === 1) ? 'day' : 'days'} ${joinWithAnd(rule.date)} at ` +
        `${getTimeString(parseInt(rule.hour.toString(), 10), parseInt(rule.minute.toString(), 10))}`;
    } else if (typeof rule.date === 'string' || typeof rule.date === 'number') {
      return `on ${(typeof rule.date === 'number' || !rule.date.includes(',')) ? 'day' : 'days'} ${rule.date} at ` +
        `${getTimeString(parseInt(rule.hour.toString(), 10), parseInt(rule.minute.toString(), 10))}`;
    } else if (typeof rule.date === 'undefined' || rule.date === '*') {
      return `unknown days at ${getTimeString(parseInt(rule.hour.toString(), 10), parseInt(rule.minute.toString(), 10))}`;
    } else {
      return `Unknown`;
    }
  } else if (typeCode === 'D') {
    console.log(rule);
    if (typeof rule.hour === 'string' || typeof rule.hour === 'number') {
      return `at ${rule.hour.toString().padStart(2, '0')}:${rule.minute.toString().padStart(2, '0')}`;
    } else {
      return `at ${joinWithAnd(rule.hour.map(
        hour => getTimeString(parseInt(hour.toString(), 10), parseInt(rule.minute.toString(), 10), rule.hour.length === 1)
      ))}`;
    }
  }
  return ruleString;
}
